<template>
    <div class="main-container">
        <bread-crumb :items="breadcrumbPath" />
        <v-divider />
        <v-flex
            mt-5
            md12
            sm12
            v-cloak
            xs12
        >
                <v-toolbar
                    mt-5
                    class="elevation-1"
                    dense
                    style="max-width: 500px;"
                >
                    <v-text-field
                        @click:append="assetTableSearch = ''"
                        v-model="assetTableSearch"
                        append-icon="close"
                        hide-details
                        id="searchByName"
                        placeholder="Search"
                    />
                    <person-asset-table-filter-dialog />
                </v-toolbar>
            <ManageAssetsTable />
        </v-flex>
    </div>
</template>

<script>
import { FETCH_PERSON_ASSET_LIST, } from "@/store/person_asset/actions.js";
import { FILTER_ASSETS } from "@/store/person_asset/mutations.js";
import ManageAssetsTable from '@/views/ManageAssets/components/ManageAssetsTable.vue';
import PersonAssetTableFilterDialog from '@/views/ManageAssets/components/PersonAssetTableFilterDialog.vue';
import { mapGetters } from "vuex";

    export default {

        components: {
            ManageAssetsTable,
            PersonAssetTableFilterDialog,
        },

        data() {
            return {
                breadcrumbPath: [{text: 'Manage Assets', to: "manage-assets"}],
                loading: true,
                personnelWithAssetTitle: [],
                selectedPersonnelId: '',
                assetId: '',
            };
        },

        computed: {
            ...mapGetters(
            [
                "asset",
                "assetList",
                "editStateAsset",
            ]
            ),

            assetTableSearch: {
                get() {
                    return this.$store.state.person_asset.assetTableSearch;
                },
                set(value) {
                    this.$store.commit(FILTER_ASSETS, value);
                }
            },
        },

        mounted() {
            //this.fetchAssets();
            
            if (
            this.$route.params !== undefined
            && this.$route.params.assetId !== undefined) {
                this.assetId = this.$route.params.assetId;
            }

            if (this.assetId > 0) {
                this.fetchAsset();
            }
        },

        methods: {
            fetchAssets() {
                this.$store.dispatch(FETCH_PERSON_ASSET_LIST);
            },
            // fetchAsset() {
            //     this.$store.dispatch(FETCH_ASSET, this.assetId);
            // },
        },
    }
</script>

<style scoped>
    #assetsTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }
</style>
